import React from 'react';
import cx    from 'classnames';
import TrackingActions from 'actions/tracking_actions';

export default React.createClass({
  displayName: 'MedscapeTV.TitleBar',
  getInitialState() {
    return {
      hideShareMenu: true
    };
  },
  showShareMenu() {
    this.setState({
      hideShareMenu: false
    });
  },
  hideShareMenu() {
    this.setState({
      hideShareMenu: true
    });
  },
  shareFaceBook() {
    TrackingActions.socialMedia('fb');
    const fbShareLink       = `http://www.facebook.com/share.php?u=${window.location}?src=stfb&t=${document.title}`;
    window.open(fbShareLink);
  },
  shareTwitter() {
    TrackingActions.socialMedia('tw');
    const twitterShareLink  = `http://twitter.com/share?url=${encodeURIComponent(window.location)}?src=sttwit&text=${encodeURIComponent(document.title)}`;
    window.open(twitterShareLink);
  },
  shareGoogle() {
    TrackingActions.socialMedia('em');
    const googleShareLink   = `https://plusone.google.com/_/+1/confirm?url=${encodeURIComponent(window.location)}?src=stgoogle&title=${encodeURIComponent(document.title)}`;
    window.open(googleShareLink);
  },
  shareLinkedin() {
    TrackingActions.socialMedia('linkedin');
    const LinkedInShareLink = `https://www.linkedin.com/shareArticle?url=${window.location}&source=MedscapeTV&title=${document.title}&`;
    window.open(LinkedInShareLink);
  },
  shareEmail() {
    console.log('shareEmail');
  },
  sharePrint() {
    console.log('sharePrint');
  },
  render() {
    const shareMenuClasses = cx({
      'share-menu': true,
          'hidden': this.state.hideShareMenu
    });
    return (
        <div className="share-wrap"
             onTouchStart={this.showShareMenu}
             onMouseEnter={this.showShareMenu}
             onMouseLeave={this.hideShareMenu}>
          Share
          <div className={shareMenuClasses} onMouseLeave={this.hideShareMenu}>
            <div onClick={this.shareFaceBook}  className="facebook-button">Facebook</div>
            <div onClick={this.shareTwitter}   className="twitter-button">Twitter</div>
            <div onClick={this.shareGoogle}    className="google-button">Google</div>
            <div onClick={this.shareLinkedin}  className="linkedIn-button">LinkedIn</div>
            {/*
            <div onClick={this.shareEmail}    className="email-button">Email</div>
            <div onClick={this.sharePrint}    className="print-button">Print</div>
            */}
          </div>
        </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/medscape_tv/share_menu.jsx
 **/